module.exports = __webpack_public_path__ + "static/media/1.989fa3ac.png";